import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@core/http';
import { User } from '@core/users';

@Injectable({ providedIn: 'root' })
export class UsersService {
  private readonly http = inject(ApiService);

  fetchCurrentUser(): Observable<User> {
    return this.http.get<User>('/users/current');
  }
}
